module.exports = __webpack_public_path__ + "img/ceo.90ab8ffa.jpg";